import { render } from "./BodegaPerfecta.vue?vue&type=template&id=767457ac&scoped=true"
import script from "./BodegaPerfecta.vue?vue&type=script&lang=js"
export * from "./BodegaPerfecta.vue?vue&type=script&lang=js"

import "./BodegaPerfecta.vue?vue&type=style&index=0&id=767457ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767457ac"]])

export default __exports__